import './global.scss';

//import  './my-component/front.js'
import  './my-component/nav-mobile.js'
//import  './my-component/cookieconsent.js'


import  * as megamenu from './my-component/megamenu.js'
import  * as select from './my-component/select.js'

import StickySidebar from 'sticky-sidebar-v2'
//https://github.com/iamdustan/smoothscroll
import smoothscroll from 'smoothscroll-polyfill'


let last_known_scroll_position = 0;
let ticking = false;
var candidats = new Array();;


var btComparer = document.getElementById("bt-comparer");


  // GESTION REVEAL
  const threshold = .1
  const options = {
    root: null,
    rootMargin: "0px 0px 70% 0px",
    threshold
  }
  const handleIntersect = function (entries, observer) {
    entries.forEach(function (entry) {
      if (entry.intersectionRatio > threshold) {

        entry.target.classList.remove('reveal')
        observer.unobserve(entry.target)
      }
    })
  }
  document.documentElement.classList.add('reveal-loaded')
  window.addEventListener("DOMContentLoaded", function () {
    initReveal()
  })


 // Gestion disclaimer
 const optionsDisclaimer = {
  root: null,
  rootMargin: "0px 0px 10% 0px",
  threshold
}
 const handleDisclaimer  = function (entries, observer) {
   entries.forEach(function (entry) {
     if (entry.intersectionRatio > threshold) {

      document.querySelector('.disclaimer').classList.remove('is-active')
      console.log('hide')
     }
   })
 }
 document.querySelector('.disclaimer').addEventListener("click", function(){
  document.querySelector('.disclaimer').classList.toggle('is-active')
});

 


// Init
setNavSize()

// Selects
if ( ((document.querySelector('body.candidat')) || (document.querySelector('body.theme')) || (document.querySelector('body.alliance')) ) &&  ( !document.querySelector('body.synthese') )  ) {
  select.initSelect()
}


// Smooth scroll
smoothscroll.polyfill();

// Récupération des candidats
if (candidats.length == 0) getAllCandidats()




function initReveal() {

   const observer = new IntersectionObserver(handleIntersect, options)
     const targets = document.querySelectorAll('.reveal')
     targets.forEach(function (target) {
       observer.observe(target)

     })
  
     const observerDisclaimer = new IntersectionObserver(handleDisclaimer, optionsDisclaimer)
     observerDisclaimer.observe(document.querySelector('.hide-disclaimer'))
}

// Gestion OPACITE PORTRAIT

function convertToRange(value, srcRange, dstRange){
    // value is outside source range return
    if (value < srcRange[0] || value > srcRange[1]){
      return NaN;
    }
    var srcMax = srcRange[1] - srcRange[0],
        dstMax = dstRange[1] - dstRange[0],
        adjValue = value - srcRange[0];

    return (adjValue * dstMax / srcMax) + dstRange[0];
  }


function opacitePortrait(scroll_pos) {

  if (document.getElementById('image-habillage') ) {
    if (scroll_pos <125)  document.getElementById('image-habillage').style.opacity = 1;
    else if (scroll_pos >500) document.getElementById('image-habillage').style.opacity = 0.1;
    else {
      let opacity = convertToRange(scroll_pos,[250,600],[0.05,1])
        document.getElementById('image-habillage').style.opacity = 1.05-opacity
    }

    if (scroll_pos <150)  document.getElementById('image-habillage2').style.opacity = 1;
    else if (scroll_pos >500) document.getElementById('image-habillage2').style.opacity = 0.1;
    else {
      let opacity = convertToRange(scroll_pos,[250,600],[0.05,1])
        document.getElementById('image-habillage2').style.opacity = 1.05-opacity
    }
  }

}

function isMobile() {
  try {
    document.createEvent("TouchEvent");
    return true;
  } catch (e) {
    return false;
  }
}

// if( document.getElementById("zone-bloc-estimation")) {
//   var stickyEstimation = new StickySidebar('#zone-bloc-estimation', {
//     containerSelector: '.zone-analyses',
//     innerWrapperSelector: '.bloc-estimation',
//     topSpacing: 200,
//     bottomSpacing: 50
//   });
// }

// Gestion navigation dans une page
if( document.getElementById("zone-nav-page")) {

  // Sticky nav
  var stickyEstimation = new StickySidebar('#zone-nav-page', {
    containerSelector: '.zone-synthese-nav',
    innerWrapperSelector: '.nav-page',
    topSpacing: 440,
    bottomSpacing: 50
  });

  // Menu au scroll
  const threshold = .1
  const optionsSelect = {
    root: null,
    rootMargin: "0px 0px -50% 0px",
    threshold
  }

  let currentSection

  const handleSections = function (entries, observer) {
    entries.forEach(function (entry) {
      if (entry.intersectionRatio > threshold) {

        currentSection = entry.target.dataset.id;
    
        let nav = document.querySelectorAll('.nav-page li a')
        for (let i = 0; i < nav.length; i++) {
          if ( nav[i].dataset.ancre == currentSection ) {
            nav[i].classList.add('actif')
          } else nav[i].classList.remove('actif')
        }

      }
    })
  }

  const observer = new IntersectionObserver(handleSections, optionsSelect)
  const targets = document.querySelectorAll('.page-section')
  targets.forEach(function (target) {
    observer.observe(target)
  })

}


// Evenements
let sens;

window.addEventListener('scroll', function(e) {


  // Scroll bas -> en mobile revenir à la nav normale
  if ( last_known_scroll_position > window.scrollY ) {
     sens = 'haut'
  } else sens ='bas'


  last_known_scroll_position = window.scrollY;
  //console.log(last_known_scroll_position);

  if (!ticking) {
    window.requestAnimationFrame(function() {

      if (sens == 'haut') {
        document.querySelector('nav').classList.add('haut')
      } else {
        document.querySelector('nav').classList.remove('haut')
      }

      // Top des megamenus
      if (document.querySelector(".megamenu.actif")) document.querySelector(".megamenu.actif").style.top =  document.querySelector('nav').offsetHeight+'px'

      // // Bloc estimation
      // let zoneContenu = document.querySelector('.zone-analyse')

      // Supprimer le reveal du bloc estimation

      if( document.getElementById("bloc-estimation")) {
          var blocEstimation = document.getElementById("bloc-estimation");
          if (last_known_scroll_position>=320) {
            blocEstimation.classList.remove('reveal-1')
          }
        }



        // Bouton France
        if ( ( document.querySelector('body.candidat') || document.querySelector('body.theme') ) && (!document.querySelector("body.synthese")) ) {
          var france = document.getElementById("bt-france");
          if (last_known_scroll_position > 380) {

            let currentTheme = select.currentTheme
            let affiche = false;
            if ( currentTheme != 'europe-et-international')  affiche = true

            // Forcer l'affichage 
            affiche = true

            
            if (affiche) {
              // Tester si le thème existe dans la France en chiffre
              france.classList.remove("masque");
            } else {
              france.classList.add("masque");
            }

            
          } else if (last_known_scroll_position < 379) {
            france.classList.add("masque");
          }
        }
      




      // Opacité du portrait
      opacitePortrait(last_known_scroll_position);

      // Modification du menu
      var element = document.getElementById("navigation-principale");

        if (last_known_scroll_position < 250) {
          // Front
          if (document.querySelector('body.front') ) element.classList.remove("mini-accueil");
          // Page intérieure
          else if ( (!document.querySelector('body.chiffres')) && (element.classList.contains('mini')) ) element.classList.remove("mini");


        } else if (last_known_scroll_position > 250) {
          // Front
          if (document.querySelector('body.front') )  element.classList.add("mini-accueil");
           // Page intérieure
           else if ( (!document.querySelector('body.chiffres')) &&  (!element.classList.contains('mini')) ) element.classList.add("mini");
        }



      if ( document.querySelector('.candidat') &&  !document.querySelector('.synthese')) {
          // Bouton comparer

          if (last_known_scroll_position < 300) {
            btComparer.classList.remove("masque");
          } else if (last_known_scroll_position > 300) {
            btComparer.classList.add("masque");
          }
        }

    

      // Image d'ahibillage toujours à la même hauteur  -> poru compenser position:fixed qui ne peut êtr eutilisé
      // var image = document.getElementById("image-habillage");
      // image.style.setProperty('--scroll', last_known_scroll_position + 'px');


      // fermer le menu s'il à été ouvert en mode mini
      var burger = document.querySelector('.burger-desktop');
      if (burger.classList.contains('actif')) {
        element.classList.remove('menu-ouvert')
        burger.classList.remove('actif')

        megamenu.fermeMegamenu ()
    }



      // Barre de lecture
      var progress = document.querySelector('.barre');

      var scrollTop = last_known_scroll_position;
      var docHeight = document.body.scrollHeight;
      var winHeight = window.innerHeight;
      var scrollPercent = (scrollTop) / (docHeight - winHeight);
      var scrollPercentRounded = Math.round(scrollPercent * 100);
      progress.style.setProperty('--scroll', scrollPercentRounded + '%');

      ticking = false;
    });

    ticking = true;
  }
});





// Afficher le menu en mode mini navigation
document.querySelector('.burger-desktop').addEventListener("click", function(){
  var burger = document.querySelector('.burger-desktop')
  burger.classList.toggle('actif');
  var element = document.getElementById("navigation-principale");
  if (burger.classList.contains('actif')) {
    element.classList.add('menu-ouvert')
  } else {
    element.classList.remove('menu-ouvert')
  };
});


// Biographie
if ( document.querySelector(".button.biographie") ) {
  document.querySelector(".button.biographie").addEventListener("click", function(){
    clicBiographie()
   });
   document.querySelector(".conteneur-biographie .bt-fermer").addEventListener("click", function(){
    fermeBiographie()
   });
   function clicBiographie () {
    prepareComparaison();
    var element = document.querySelector(".conteneur-biographie");
    element.classList.add("actif");
    var element2 = document.getElementById("overlay");
    element2.classList.add("actif");
    document.querySelector('body').style.position = 'fixed'
   }

   function fermeBiographie() {
    var element = document.querySelector(".conteneur-biographie");
    element.classList.remove("actif");
    var element2 = document.getElementById("overlay");
    element2.classList.remove("actif");
    document.querySelector('body').style.position = 'relative'
   }

}




// Bouton comparaison
if ( (document.querySelector("body.candidat")) && (!document.querySelector("body.synthese")) )  {
  document.getElementById("bt-comparer").addEventListener("click", function(){
    clicComparasion()
   });
  
   if (document.querySelector(".button.changer")) document.querySelector(".button.changer").addEventListener("click", function(){
    clicComparasion()
   });
  
   document.querySelector(".conteneur-comparaison .bt-fermer").addEventListener("click", function(){
    fermeChoixComparaison()
   });
}


 function clicComparasion () {
  prepareComparaison();
  var element = document.getElementById("conteneur-comparaison");
  element.classList.add("actif");
  var element2 = document.getElementById("overlay");
  element2.classList.add("actif");
 }

 function fermeChoixComparaison() {

  var element = document.getElementById("conteneur-comparaison");
  element.classList.remove("actif");
  var element2 = document.getElementById("overlay");
  element2.classList.remove("actif");

  for (let i=1;i<candidats.length;i++) {
    // apparition des candidats
    setTimeout(function() {
      document.querySelector('.zone-comparaison-candidats .candidat-'+i).classList.remove('affiche')
      document.querySelector('.zone-comparaison-candidats .candidat-'+i).classList.remove('affiche-termine')
      },  (300*i ) );
  }

 }

 function prepareComparaison() {

    // activer uniquement les autres candidats
    let currentCandidat = document.querySelector('body').dataset.candidat_id;
    let zone_comparaison =  document.querySelector(".zone-comparaison-candidats")
    zone_comparaison.innerHTML = '' // vider



    var num = 1;
    for (var key in candidats) {
      if (candidats.hasOwnProperty(key)) {
        var candidat = candidats[key]
        if (candidat.ID != currentCandidat) {

          // Création des candidats à comparer
          // <div class="portrait-candidat candidat-1 marine-le-pen" data-nom="Marine Le Pen" id="marine-le-pen"></div>
          const node = document.createElement("div")
          node.classList.add('portrait-candidat')
          node.classList.add('candidat-'+num)
          node.classList.add(candidat.post_name)
          node.dataset.nom = candidat.post_title
          node.setAttribute('id',candidat.ID)
          node.dataset.url = candidat.post_name
          zone_comparaison.appendChild(node)
          num++
        }
    }

 }

  for (let i=1;i<candidats.length;i++) {

    // apparition des candidats
    setTimeout(function() {
      document.querySelector('.zone-comparaison-candidats .candidat-'+i).classList.add('affiche')
      }, 500 + (300*i ) );
      // activer les canduidats une fois l'animation terminée
    setTimeout(function() {
      document.querySelector('.zone-comparaison-candidats .candidat-'+i).classList.add('affiche-termine')
      activePortaits(i)
      }, 1200 + (300*i ) );
  }

 }


 function activePortaits(num) {
  // Opacité des candidat au roll over
  // let portraitsRoll = document.querySelectorAll('.portrait-candidat.affiche-termine');
  // for (let i = 0; i < portraitsRoll.length; i++) {

      let portrait =  document.querySelector('.zone-comparaison-candidats .candidat-'+num)
      // Rollover
      portrait.addEventListener("mouseenter", function(e) {
        let selectsPortraits =  document.querySelectorAll('.portrait-candidat');
        for (let i = 0; i < selectsPortraits.length; i++) {
          selectsPortraits[i].classList.remove('actif');
          selectsPortraits[i].classList.add('inactif');
        }
        let portraitActif = e.target.getAttribute('id');
        document.getElementById(portraitActif).classList.remove('inactif')
        let nom = document.getElementById(portraitActif).dataset.nom;
        document.getElementById( 'zone-nom-comparaison').innerHTML = nom
      });

      portrait.addEventListener("mouseleave", function(e) {
        let selectsPortraits =  document.querySelectorAll('.portrait-candidat');
        for (let i = 0; i < selectsPortraits.length; i++) {
          selectsPortraits[i].classList.remove('actif');
          selectsPortraits[i].classList.remove('inactif');
        }
        document.getElementById( 'zone-nom-comparaison').innerHTML = '...'
      });

      //Click
      portrait.addEventListener("click", function(e) {
        let candidat = e.target.getAttribute('id');
        let candidatUrl = e.target.dataset.url
        let candidatNom = e.target.dataset.nom

        activeComparaison(candidat)

        });
    // }
}


function activeComparaison(idcandidat2) {

  changeGenreComparaison()


  var candidat2 = getCandidat(idcandidat2)

  var currentCandidat = document.querySelector('body').dataset.candidat_id;
  var currentCandidatUrl = document.querySelector('body').dataset.candidat_url;


  // Récupérer les contenus
  const url = 'https://'+window.location.host+'/presidentielle-2022/wp-json/p2022/v1/comparaison/'+currentCandidat+'_'+idcandidat2;

    fetch(url)
    .then((resp) => resp.json())
    .then(function(data) {

      // console.log('Retour API REST')
      // console.log(url)
      // console.log(data);

      let currentCandidat =  getCurrentCandidat()
     window.history.pushState("https://"+window.location.host,  'titre',"./"+currentCandidatUrl+"_comparaison_"+candidat2.post_name);

     document.title = currentCandidat.post_title+' - '+candidat2.post_title+  " | Présidentielle 2022 | Institut Montaigne";

     document.querySelector("body").classList.add('comparaison');
      document.querySelector('.zone-propositions-comparaison').innerHTML = data.html;

      document.querySelector('.zone-nav-comparaison .titre-xs').innerHTML = candidat2.post_title;
      document.querySelector('.zone-nav-comparaison .parti').innerHTML = candidat2.parti;

      // Reset reveal
      initReveal()

      // Mise à jour des tailles des zones de contenu
      document.querySelector('.zone-candidat-1').classList.remove("is-8", "is-offset-2", "is-7-mobile", "is-offset-4-mobile")
      document.querySelector('.zone-candidat-1').classList.add("is-6", "is-offset-0", "is-5-mobile", "is-offset-1-mobile")
      document.querySelector('.zone-candidat-2').classList.add("is-6", "is-offset-0", "is-5-mobile", "is-offset-0-mobile")


      // Chercher les données du candidat actif dans l'objet des candidats


      // Remplissage
      document.querySelector('.zone-candidat-2 .titre-l').innerHTML = candidat2.prenom+'<br>'+candidat2.nom;
      document.querySelector('.zone-candidat-2 .titre-xxs').innerHTML = candidat2.parti;

      // Supprimer l'ancien portrait et ajouter le nouveau
      document.getElementById('image-habillage2').className = 'image-habillage image-habillage-candidat-2 '+ candidat2.post_name// className récupè!re une chaine de caractère qui sera plus facile à traiter


      fermeChoixComparaison()

      // Scroll Top
      window.scrollTo({ top: 0, behavior: 'smooth' })

      // Masquer bouton France
      document.querySelector('.bt-france').classList.add('masque')

      // Masquer la zone de contenu candidat
      document.querySelector('.zone-propositions-candidat').classList.add('masque')


    })
    .catch(function(error) {
      console.log(error);
      fermeChoixComparaison()
    });


}

if (document.querySelector('.bt-fermer-comparaison')) document.querySelector(".bt-fermer-comparaison").addEventListener("click",function(e) {

    changeGenre()

     // Remplissage
     document.querySelector('.zone-candidat-2 .titre-l').innerHTML = '';
     document.querySelector('.zone-candidat-2 .titre-xxs').innerHTML = '';

     // Supprimer l'ancien portrait et ajouter le nouveau
     document.getElementById('image-habillage2').className = 'image-habillage image-habillage-candidat-2 '// className récupè!re une chaine de caractère qui sera plus facile à traiter

     // Scroll Top
     window.scrollTo({ top: 0, behavior: 'smooth' })

     // Masquer bouton France
     document.querySelector('.bt-comparer').classList.remove('masque')

     // Afficher la zone de contenu candidat et vider
     document.querySelector('.zone-propositions-comparaison').innerHTML = '';
     document.querySelector('.zone-propositions-candidat').classList.remove('masque')

     // Reset reveal
     initReveal()

     // Mise à jour des tailles des zones de contenu

     document.querySelector('.zone-candidat-1').classList.remove("is-6", "is-offset-0", "is-5-mobile", "is-offset-1-mobile")
     document.querySelector('.zone-candidat-1').classList.add("is-8", "is-offset-2", "is-7-mobile", "is-offset-4-mobile")

     let currentCandidat =  getCurrentCandidat()
     window.history.pushState("https://"+window.location.host, "Sample Title", "./"+currentCandidat.post_name);
     document.title = currentCandidat.post_title+  " | Présidentielle 2022 | Institut Montaigne";


     document.querySelector("body").classList.remove('comparaison');
})

function getCurrentCandidat() {

  let currentCandidat = document.querySelector('body').dataset.candidat_id;
  return  getCandidat(currentCandidat)

}

function getCandidat(id) {

  for (var key in candidats) {
    if (candidats.hasOwnProperty(key)) {
      var candidat = candidats[key]
      if (candidat.ID == id) {
        return candidat
      }

    }
  }

}

 // Gestion globale des boutons
 if ( document.getElementById("nav-analyses-simple") ) {
  document.getElementById("nav-analyses-simple").addEventListener("click",function(e) {
    desactiveNavAnalyse();
    document.getElementById("analyse-detail").classList.remove("visible");
    document.getElementById("analyse-simple").classList.add("visible");
    document.getElementById('nav-analyses-simple').classList.add('actif');
  });

  document.getElementById("nav-analyses-detail").addEventListener("click",function(e) {
    desactiveNavAnalyse();
    document.getElementById("analyse-detail").classList.add("visible");
    document.getElementById("analyse-simple").classList.remove("visible");
    document.getElementById('nav-analyses-detail').classList.add('actif');
  });

 }


// document.getElementById("nav-analyses-simple").addEventListener("mouseenter",function(e) {
//   console.log('enter')
// });
// document.getElementById("nav-analyses-simple").addEventListener("mouseleave",function(e) {
//   console.log('leave')
// });





function desactiveNavAnalyse() {
  const boutons = document.querySelectorAll('#nav-analyses .titre-xxs');
  boutons.forEach(bouton => {
    bouton.classList.remove('actif');
  });
}


// Resize de la fenêtre
window.addEventListener('resize', function() {
    setNavSize();
});

function setNavSize() {

  if ( document.querySelector("body.proposition") ) {
    var largeurMax = document.documentElement.clientWidth;
    var largeurElements = document.querySelector('.menu-logo').offsetWidth +   document.querySelector('.menu-scroll .titre-xxs').offsetWidth  +  document.querySelector('.menu-scroll .titre-xxs.parti').offsetWidth  +   document.querySelector('nav .level-right').offsetWidth
    document.querySelector('.menu-scroll .titre-xs').style.maxWidth = largeurMax-largeurElements-200+'px';
  }
}











  function getComparaison(id) {
    const url = 'https://'+window.location.host+'/presidentielle-2022/wp-json/p2022/v1/candidat/'+id;

    fetch(url)
    .then((resp) => resp.json())
    .then(function(data) {

    })
    .catch(function(error) {
      console.log(error);
    });

  }


function getAllCandidats() {
  const url = 'https://'+window.location.host+'/presidentielle-2022/wp-json/p2022/v1/allcandidats/';

    fetch(url)
    .then((resp) => resp.json())
    .then(function(data) {

      candidats=data;
      if (btComparer && !document.querySelector('.synthese') ) btComparer.classList.remove("masque");

    })
    .catch(function(error) {
      console.log(error);
    });

}


document.querySelector('.footer-select-themes').addEventListener('click', function () {

  document.querySelector('.footer-select-themes').classList.toggle('actif')
})


var myLinks = document.querySelectorAll("a.ligne-proposition");
for (var i = 0; i < myLinks.length; i++) {
  myLinks[i].addEventListener('click', function (event) {
  if (event.target.classList.contains("inactif")) {
    event.preventDefault();
  }
  });
}



// Gestion page candidat

if (document.querySelector('.candidat')) {
  changeGenre()
}

function changeGenreComparaison() {
  document.querySelector('.zone-titre-menu-propositions').innerHTML = 'Propositions des candidats : '
}

function changeGenre() {
  let currentCandidat = document.querySelector('body').dataset.candidat_id

  for (var key in candidats) {
    if (candidats.hasOwnProperty(key)) {
      var candidat = candidats[key]
      if (candidat.ID == currentCandidat) {

        messageGenre(candidat.genre)
      }

    }
  };

}
function messageGenre(genre) {
  if (genre == 1) document.querySelector('.zone-titre-menu-propositions').innerHTML = 'Proposisitons de la candidate : '
  else document.querySelector('.zone-titre-menu-propositions').innerHTML = 'Propositions du candidat : '
}


// Gestion footer

const optionsFooter = {
  root: null,
  rootMargin: "0px 0px -20% 0px",
  threshold
}


const handleFooter = function (entries, observer) {
  entries.forEach(function (entry) {

    if (document.getElementById('image-habillage')) {
      if (entry.intersectionRatio > threshold) {
        document.getElementById('image-habillage').classList.add('masque');
        document.getElementById('image-habillage2').classList.add('masque');
        if (document.getElementById('bt-france')) document.getElementById('bt-france').classList.add('masque-footer');
      }
      else {
        document.getElementById('image-habillage').classList.remove('masque');
        document.getElementById('image-habillage2').classList.remove('masque');
        if (document.getElementById('bt-france'))  document.getElementById('bt-france').classList.remove('masque-footer');
      }
    }
    
  })
}

const observerFooter = new IntersectionObserver(handleFooter, optionsFooter)
const targetsobserverFooter = document.querySelector('footer')
observerFooter.observe(targetsobserverFooter)





// Faire apparaitre le menu déroulant du menu uniquement si celui du haut n'est plsu visible
if (document.querySelector('.zone-selecteur')) {
  const handleSelect = function (entries, observer) {
    entries.forEach(function (entry) {
      if (entry.intersectionRatio > threshold) {

        if ( ((document.querySelector('body.candidat')) || (document.querySelector('body.theme'))) &&(!document.querySelector("body.synthese")) )  document.querySelector('nav .zone-select').classList.remove('affiche')
      }
      else {
        if ( ((document.querySelector('body.candidat')) || (document.querySelector('body.theme'))) && (!document.querySelector("body.synthese")) )   document.querySelector('nav .zone-select').classList.add('affiche')
      }
    })
  }
  const observerSelect = new IntersectionObserver(handleSelect, options)
  const targetsobserverSelect = document.querySelector('.zone-selecteur')
  observerSelect.observe(targetsobserverSelect)
}


window.onpopstate = function(event) {

  console.log(event)
  location.reload();
};



if (document.querySelector('.button.plus')) {

  document.querySelector('.button.plus').addEventListener('click', function () {

    let page = Number(document.querySelector('.zone-affichage-actualites').dataset.page)+1

    const url = 'https://'+window.location.host+'/presidentielle-2022/wp-json/p2022/v1/actualites/9/'+page;

    // Affihce Preload
    document.querySelector('.zone-loader-actualites').classList.add('actif')


    document.querySelector('.zone-affichage-actualites').dataset.page =
    fetch(url)
    .then((resp) => resp.json())
    .then(function(data) {


      document.querySelector('.zone-affichage-actualites').dataset.page = page
      document.querySelector('.zone-affichage-actualites').innerHTML += data
      initReveal()

      // MAsque préload
      document.querySelector('.zone-loader-actualites').classList.remove('actif')

    })
    .catch(function(error) {
      console.log(error);
    });

  })

}





if (document.querySelector('.nav-page')) {

  var myLinks = document.querySelectorAll(".nav-page a");
  for (var i = 0; i < myLinks.length; i++) {
    myLinks[i].addEventListener('click', function (event) {
      event.preventDefault();
      let ancre = event.target.dataset.ancre;
   
      const yOffset = -130;
      const element = document.getElementById(ancre);
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({top: y, behavior: 'smooth'});

  });
}

}